import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PaymentMethodCode } from '../../../pay/models/payment-method-code.enum';
import { PaymentMethod } from '../../../pay/models/payment-method.model';
import { PaykaCurrencyPipe } from '../../utils/pipes/payka-currency.pipe';
import { DecimalPipe } from '@angular/common';

@Component({
standalone: false,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PaymentMethodChooserComponent),
    }, PaykaCurrencyPipe, DecimalPipe,
  ],
  selector: 'app-payment-method-chooser',
  styleUrls: ['./payment-method-chooser.component.scss'],
  templateUrl: './payment-method-chooser.component.html',
})
export class PaymentMethodChooserComponent implements ControlValueAccessor {
  @Input()
  public methods: PaymentMethod[];

  @Input()
  public disabledChooser: boolean;

  @Input()
  public inProgress: boolean;

  @Input() public amount: number;

  @Output()
  public disabledMethodClicked = new EventEmitter<PaymentMethod>();

  public methodControl = new FormControl();
  public paymentMethodCode = PaymentMethodCode;

  constructor() {
  }

  public registerOnChange(fn: any): void {

    this.methodControl.valueChanges.subscribe(fn);
  }

  public isChosen(method: PaymentMethod) {
    return (this.methodControl.value as PaymentMethodCode) === method.code;
  }

  public registerOnTouched(): void {
  }

  public writeValue(value: PaymentMethodCode): void {
    if (value) {
      this.methodControl.setValue(value, { emitEvent: false });
    }
  }

  public onMethodClicked(method: PaymentMethod): void {
    if (method.available) {
      this.methodControl.setValue(method.code);
    } else {
      this.disabledMethodClicked.emit(method);
    }
  }
}
